
import { PostHeader } from "./PostHeader";
import { Badge } from "@/components/ui/badge";

// Check if Badge is properly imported
console.log("Badge component:", Badge);

interface PostModalHeaderProps {
  profile: {
    id: string;
    username: string;
    avatar_url: string;
  };
  title?: string;
  description?: string;
  category?: string;
  createdAt: string;
}

export function PostModalHeader({
  profile,
  title,
  description,
  category,
  createdAt
}: PostModalHeaderProps) {
  // Additional check to ensure Badge is available in the render function
  console.log("Badge in render:", Badge);
  
  return (
    <div className="p-6">
      <PostHeader profile={profile} createdAt={createdAt} />
      
      {title && <h2 className="text-xl font-semibold mb-2">{title}</h2>}
      {description && <p className="text-muted-foreground mb-4">{description}</p>}
      {category && (
        <div className="mb-4">
          <Badge variant="secondary">#{category}</Badge>
        </div>
      )}
    </div>
  );
}
